import React, { Component } from "react";
import { Row, Col, Drawer, Input, Tooltip } from "antd";
import close from "../images/GroupAdmincloseIcon.svg";

export default class AddNpiGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  DeleteFromList = (item) => {
    this.props.DeleteNPI(item);
  };

  getActiveNpisLen = () => {
    let npis = this.props.NPIListData.filter(item => !item.delete)
    if(npis) return (npis.length).toString()
    else return "00"
  }

  submitHandler = () => {
    this.props.createCombination()
    this.props.closeDrawer();
  };

  render() {
    return (
      <>
      <Row>
        <Col className="dic-card p-3">
          <Row>
            <Col className="header-text mb-3">
              {this.getActiveNpisLen()} 
              {this.getActiveNpisLen() > 1 ? ' NPIs Added' : ' NPI Added'}
            </Col>
          </Row>
          <Row className="pt-4">
            {this.props.NPIListData.length > 0 &&
              this.props.NPIListData.map((item) => {
                if(!item.delete) {
                  return (
                    <Col span={4} className="npi-chip mr-4 py-1" key={item.npi}>
                      <Col className="npi-chip-text pl-2 pr-1 font-medium" style={{width: "500px"}}>
                        <Tooltip title={item.npi} placement="bottom">
                          {item.name && item.name.length > 15 ? item.name.slice(0,16) + '...' : item.name}{" "} 
                          <span style={{ float: "right" }}>
                            <img
                              src={close}
                              onClick={() => this.DeleteFromList(item)}
                            ></img>
                          </span>
                          </Tooltip>
                      </Col>
                    </Col>
                  );
                }
              })}
          </Row>
        </Col>
      </Row>
      </>
      
    );
  }
}
